import { render, staticRenderFns } from "./RoleHistory.vue?vue&type=template&id=73a1aa35&scoped=true&"
import script from "./RoleHistory.vue?vue&type=script&lang=js&"
export * from "./RoleHistory.vue?vue&type=script&lang=js&"
import style0 from "./RoleHistory.vue?vue&type=style&index=0&id=73a1aa35&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a1aa35",
  null
  
)

export default component.exports